import _ from 'lodash'
import I18n from '../localization'

export const ENLM_TOKEN_COOKIE_NAME = "_enlighten_manager_token"
export const AIR_SYSTEM_LOCAL_STORAGE = 'airSystems'
export const IQ_AIR_DEVICES_LOCAL_STORAGE = 'IQAirDevices'
export const IQ_AIR_I18n_KEY = 'mobile.devices.airDeviceInfo'
export const PLATFORM_IOS = 'iOS'

export const HTTPS_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
}

export const PAGES = {
  SITE_DETAILS: 'SITE_DETAILS',
  AIR_DEVICES_PROVISION: 'AIR_DEVICES_PROVISION',
  CONFIRM_SITE: 'CONFIRM_SITE',
  AIR_DEVICE_INTEGRATION: 'AIR_DEVICE_INTEGRATION',
  IQ_AIR_SETTING:'IQ_AIR_SETTING',
  AIR_SYSTEM_SETTING:'AIR_SYSTEM_SETTING',
  HVAC_DETAILS: 'HVAC_DETAILS',
  HVAC_ENERGY_MODE: 'HVAC_ENERGY_MODE',
  LINK_HVAC_TO_THERMOSTAT: 'LINK_HVAC_TO_THERMOSTAT',
  IQ_AIR_SCHEDULER:'IQ_AIR_SCHEDULER'
}

export const EVSE_NATIVE_METHODS = {
  DID_GOT_CAMERA_PERMISSIONS: 'DID_GOT_CAMERA_PERMISSIONS',
  DID_PRESS_BACK_BUTTON: 'DID_PRESS_BACK_BUTTON',
  NOTIFY_LIFECYCLE_STATE: 'enhoNotifyLifecycleState',
}

export const EVSE_NATIVE_APIS = {
  STATUS_CAMERA: 'enphase://evse?status=camera'
}

export const KEY = {
  ORIGIN: 'origin'
}

export const TOKEN_KEY_MAP = {
  "/batteryConfig/": "bp_csrfToken",
  "/hems/": "csrfToken",
  "/homeconnect/": "hc_csrfToken",
};

export const STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
}

export const SITE_VALIDATE_CODES = {
  LAT_LONG_UNABLE: 2014,
  TIMEZONE_UNABLE: 2013,
  SERIAL_NUMBER_NOT_FOUND : 1002,
  INVALID_SKU_FOR_UK : 1012,
  INVALID_COUNTRY_FOR_UK_SKU : 1013
}

export const MODES = {
  AUTO: "AUTO",
  HEAT: "HEAT",
  COOL: "COOL",
  OFF: "OFF",
  ON: "ON",
  CIRCULATE: "CIRCULATE",
};

export const HVAC_TYPES = {
  HEAT: 'HEAT',
  COOL: 'COOL',
  HEAT_COOL: 'HEAT_COOL',
  UNKNOWN: 'UNKNOWN'
}

export const PROVISIONING_FAILURE_STAGES = {
  INVALID_SN: 'INVALID_SN',
  SN_ALREADY_EXIST: 'SN_ALREADY_EXIST',
  SITE_CREATION: 'SITE_CREATION',
  SITE_DEVICE_LINK: 'SITE_DEVICE_LINK',
  CREATE_CUSTOMER_FAILED: 'CREATE_CUSTOMER_FAILED'
}

export const IQ_AIR_MODEL = {
  IQ_AIR_HUB: {
    ID: 'IQ_AIR_HUB',
    HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirHubTitle'),
    INST_HEADING: I18n.t('mobile.AirDeviceProvisioning.instSubHeading1'),
    INST_LINE_1: I18n.t('mobile.AirDeviceProvisioning.instructionsLi1A'),
    INST_LINE_2: I18n.t('mobile.AirDeviceProvisioning.instructionsLi2A'),
    INST_LINE_3A: '',
    INST_LINE_3B: '',
    INST_LINE_4A : '',
    INST_LINE_4B : '',
    CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheckAsk'),
    SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1A"),
    SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1A"),
    SETUP_SUCCESS_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading2A"),
    SETUP_SUCCESS_SUBHEADING: '',
    SETUP_FAIL_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFail"),
    SETUP_FAIL_HEADINGA1: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA1"),
    SETUP_FAIL_HEADINGA2: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA2"),
    DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirPrimary"),
  },
  IQ_AIR_DISPLAY: {
    ID: 'IQ_AIR_DISPLAY',
    HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirDisplayTitle'),
    INST_HEADING: I18n.t('mobile.AirDeviceProvisioning.instSubHeading2'),
    INST_LINE_1: I18n.t('mobile.AirDeviceProvisioning.instructionsLi1B'),
    INST_LINE_2: I18n.t('mobile.AirDeviceProvisioning.instructionsLi2B'),
    INST_LINE_3A: I18n.t('mobile.AirDeviceProvisioning.instructionsLi3A'),
    INST_LINE_3B: I18n.t('mobile.AirDeviceProvisioning.instructionsLi3B'),
    INST_LINE_4A : I18n.t('mobile.AirDeviceProvisioning.instructionsLi4A'),
    INST_LINE_4B : I18n.t('mobile.AirDeviceProvisioning.instructionsLi4B'),
    CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheck'),
    SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1B"),
    SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1B"),
    SETUP_SUCCESS_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading2B"),
    SETUP_SUCCESS_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading2B"),
    DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirSecondary"),
  }
}

export const AIR_MODE = {
  UNKNOWN: 'UNKNOWN',
  COOLING: 'COOLING',
  HEATING: 'HEATING',
  IDLE: 'IDLE',
}

export const APP_SOURCE = {
  ENHO: 'enho',
  ENL: 'enl'
}

export const DEVICE_PROVISIONING_ERRORS = {
  DEVICE_ALREADY_REGISTERED: PROVISIONING_FAILURE_STAGES.SN_ALREADY_EXIST,
  INVALID_DEVICE_INVENTORY: PROVISIONING_FAILURE_STAGES.INVALID_SN
};

export const ENERGY_MODES={
  MANUAL:'Manual Mode',
  SMART:'Smart Mode',
  SCHEDULE:'Scheduled Mode'
}

export const ENERGY_MODES_API_VALUES = {
  SMART: 'SMART',
  MANUAL: 'MANUAL',
  SCHEDULE: 'SCHEDULE'
}

export const SETPOINT_COMFORT_MAP = {
  heat_setpoint: 'heat_comfort_range',
  cool_setpoint: 'cool_comfort_range'
}

export const ENERGY_SOURCE = {
  ELECTRIC: 'ELECTRIC',
  HYBRID: 'HYBRID',
  GAS: 'GAS'
}

export const HOURS = 24;

export const ROW_HEIGHT = 30;

export const DAYS = ["M", "T", "W", "T", "F", "S", "S"];

export const BLOCK_GAP = 0.5;

export const DAYS_CODE={'monday':0,'tuesday':1,'wednesday':2,'thursday':3,'friday':4,'saturday':5,'sunday':6}

export const SCENES = [
    { name: "Home", color: "#01B5DE", disabled: false },
    { name: "Away", color: "#DFDFDF", disabled: false },
    { name: "Night", color: "#99E1F2", disabled: false },
    { name: "Comfort", color: "#C7B0D5", disabled: false },
];

export const POWER_PLATE_GUIDE_URL = "https://enphase.com/download/quick-install-guide-power-plate"
export const IQ_AIR_CONTACT_SUPPORT = "https://enphase.com/support"